import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiNewsService } from '../../../../services/news/api/api-news.service';
import { AlertsService } from '../../../../services/alerts.service';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';

@Component({
  selector: 'app-news-reward-add-modal',
  templateUrl: './news-reward-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class NewsRewardAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  newsId: number = 0;
  currencyType: number = 0;
  currencyQuantity: number = 0;
  currencyTicketCost: number = 0;

  readonly currencyTypes = Object.entries(UserCurrencyType).filter(([, v]) => typeof v === 'number') as [string, number][];

  private callbackSaved?: () => void;

  constructor(private apiNewsService: ApiNewsService, private alertsService: AlertsService) {}

  show(newsId: number, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.newsId = newsId;
    this.currencyType = 0;
    this.currencyQuantity = 0;
    this.currencyTicketCost = 0;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiNewsService.addNewsReward(this.newsId, this.currencyType, this.currencyQuantity, this.currencyTicketCost).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Reward added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding reward : ' + error);
      }
    );
  }
}
